import React from 'react';

import getStripeConnectUrl from '@dashboard/services/getStripeConnectUrl';

import Logo from '@dashboard/components/Logo';
import Button from '@dashboard/components/Button';
import Link from '@dashboard/components/Link';
import Dialog from '@dashboard/components/Dialog';

import StripeLogo from './stripe.png';

export default function ConnectStripeDialog({ onClose, trigger, defaultIsOpen, open }) {
  return (
    <Dialog
      onCancel={onClose}
      trigger={trigger}
      confirmButton={null}
      cancelButton={null}
      defaultIsOpen={defaultIsOpen}
      open={open}
      size="xl"
    >
      <div className="text-center">
        <div className="flex justify-center w-full mt-6 mb-8">
          <div className="flex flex-row justify-between w-full relative gap-x-10">
            <div className="w-full flex items-center border border-gray-100 rounded p-4 bg-white z-10">
              <div className="h-auto mx-auto">
                <Logo size={80} />
              </div>
            </div>
            <div className="bg-gray-100 my-auto absolute top-0 bottom-0 w-full h-px" />
            <div className="w-full flex items-center border border-gray-100 rounded p-4 bg-white z-10">
              <img className="h-20 mx-auto" src={StripeLogo} />
            </div>
          </div>
        </div>

        <h2 className="text-3xl mb-2">Connect your Stripe account</h2>

        <p className="text-gray-800 text-xl mb-8 max-w-lg mx-auto">
          Disconnect at any time. We never hold your funds.
        </p>

        <Button
          to={`${getStripeConnectUrl()}`}
          target="_top"
          appearance="primary"
          size="full"
          className="px-24 mb-4"
        >
          Connect with Stripe
        </Button>

        <p className="text-gray-700 font-xs">
          We use Stripe to process your payments. Stripe is a
          <br />
          modern & secure payment processor.{' '}
          <Link to="https://stripe.com" blank className="underline">
            Learn more
          </Link>
        </p>
      </div>
    </Dialog>
  );
}
